import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// i18n initializes on import — must happen before any component renders.
import '@/lib/i18n';

import App from '@/App';
import { installAutoSync } from '@/lib/db/auto-sync';
import '@/styles.css';

/**
 * Entry point — Family
 *
 * - i18next initialized (4 languages bundled).
 * - TanStack Query handles server state.
 * - StrictMode catches unsafe lifecycles in dev.
 */

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Aile mesajları yavaş değişmez; cache agresif.
      staleTime: 60_000, // 1 dk
      gcTime: 5 * 60_000, // 5 dk
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

// Bug 9 fix (Oturum 7): Offline outbox auto-sync hook'u boot'ta başlat.
// Daha önce çağrılmadığı için Chat closed iken pending mesajlar retry edilmez,
// network glitch'te mesaj sessizce kaybolurdu. installAutoSync idempotent.
installAutoSync();

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
);
